export const tagsStringToArray = (tagsString) => {
  let response = [];
  if(tagsString && tagsString.length) {
    tagsString = tagsString.replace(/ /g, '');
    response = tagsString.split(',');
  }
  return response;
}

export const tagsArrayToString = (tagsArray) => {
  let response = "";
  if(tagsArray && tagsArray.length) {
    tagsArray.forEach((value, index) => {
      if(index === tagsArray.length - 1) {
        response += value;
      } else {
        response += `${value},`;
      }
    });
  }
  return response;
}
